import _axios from 'axios';
import { URL } from '@/services/config';

const axios = _axios.create({
  baseURL: URL,
});

export function requestChangePasswordEmail(email) {
  let encodedEmail = encodeURIComponent(email);
  let endpoint = `/auth/resetpassword/request?email=${encodedEmail}`;
  return axios.get(endpoint);
}

export function changePassword(password, key) {
  let encodedKey = encodeURIComponent(key);
  const randNum = Math.floor(10000000 + Math.random() * 90000000).toString();
  return axios.post(`/auth/resetpassword?key=${encodedKey}`, null, {
    headers: {
      Authorization: `Basic ${btoa(randNum)}:${btoa(password)}`,
    },
  });
}

export function verifyEmailByKey(key) {
  let encodedKey = encodeURIComponent(key);
  let endpoint = `/auth/activate?key=${encodedKey}`;
  return axios.get(endpoint);
}
